import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import Locations from 'modules/locations/components/Locations'
import { useLocations } from 'modules/locations/hooks/useLocations'

const LocationsContainer = () => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  const { locations, loading, error } = useLocations()

  return (
    <ResponsivePage.Body
      variant="full"
      widget={
        <Button
          iconName="add"
          onClick={() => {
            navigate(navigation.settings.locations.locationNew.fullPath())
          }}
          extra={{ 'data-intercom-target': 'settings-location-add-button' }}
        >
          {i18n.t('settings.locations.action')}
        </Button>
      }
      loading={loading}
      error={error}
    >
      <Locations items={locations} />
    </ResponsivePage.Body>
  )
}

export default observer(LocationsContainer)
